import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import {
  reduxForm,
  Field,
  getFormValues,
  setSubmitFailed,
  stopSubmit,
  untouch,
} from "redux-form";
import moment from "moment";
import _ from "lodash";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import {
  validateAssignedEmail,
  updateTicketAssignedAttendee,
  updateTicketAssignedError,
} from "@ticketsaction";
import { _uploadDynamicFormsFiles } from "@registrationaction";
import { renderFieldText } from "@basecomponent";
import { DATE_FORMAT, DISPLAY_BROWSER_DATE_FORMAT } from "@datehandle";
import {
  classNames,
  validateEmail,
  validateUrl,
  checkDateFormatYMD,
  validatePhoneNumbers,
  getFileDataArray,
  validateEmailDomain,
} from "@utilscommon";
import SectionList from "@formsection";
import { handleShowHide } from "@fieldshowhide";
import LocaleStrings from "@language";

let allConditionalFields = [];
let sectionWiseArray = [];

const TicketAssign = (props) => {
  const dispatch = useDispatch();
  const {
    // Parent
    assign,
    form,
    formHasError,
    availableForSelfAssign,
    clientbuildno,
    // groupTicketsArr,
    // generalTicketsArr,
    // totalGeneralTickets,
    addonTicketsArr,
    // totalAddonTickets,

    // Own
    session,
    handleSubmit,
    // pristine,
    // invalid,
    // submitting,
    formValues,
    formErrors,
    eventData,
    eventUserCategories,
    assignedAttendeeTickets,
    assignedAttendeeErrors,
    pResponseData,
    assignflow,
  } = props;
  // const [loading, setLoading] = useState(false);
  const [openContent, setContentOpen] = useState(
    assign?.type === "addon" && availableForSelfAssign ? false : true
  );
  const [lastFieldUpdated, setLastFieldUpdated] = useState("");

  const tid = assign?.ticketid;
  const tindex = assign?.index;
  const hasChild = assign?.haschild;
  const quantity = assign?.quantity;
  const position = assign?.position;
  const assignformdisplay = assign?.assignformdisplay;
  const usercategory = assign?.usercategory;
  const ticketGenre = assign?.type;
  // console.log("assign :- ", assign);

  const assigned = JSON.parse(JSON.stringify(assignedAttendeeTickets));
  const formerrors = JSON.parse(JSON.stringify(assignedAttendeeErrors));
  const isProposalTicket = !_.isEmpty(pResponseData) && tindex === 0;

  let formid = null;
  let formArray = [];
  if (ticketGenre !== "addon" && eventUserCategories?.data) {
    let matchCat = _.filter(eventUserCategories?.data, (obj) => {
      return obj.id === usercategory;
    });
    formid = matchCat?.length > 0 ? matchCat?.[0]?.formid : null;
    formArray = matchCat?.length > 0 ? JSON.parse(matchCat?.[0]?.formjson) : [];
  }

  // Get all has conditional fields
  let conditionalFields = _.filter(
    formArray,
    (obj) =>
      (obj.key === "radiobuttons" ||
        obj.key === "checkboxes" ||
        obj.key === "dropdown") &&
      obj.hasCondition
  );
  allConditionalFields = conditionalFields;

  // Create section wise fields
  let fieldsArr = JSON.parse(JSON.stringify(formArray));
  let currentSection = "";
  let sectionWiseArr = [];
  _.map(fieldsArr, (o) => {
    let key = o.key;

    if (key === "section") {
      currentSection = o?.name;
      o.elements = [];
      sectionWiseArr.push(o);
    } else {
      let index = _.findIndex(sectionWiseArr, (e) => {
        return e?.name === currentSection;
      });

      if (index >= 0) {
        sectionWiseArr[index].elements.push(o);
      }
    }
  });
  sectionWiseArray = sectionWiseArr;

  useEffect(() => {
    // console.log("formHasError :- ", formHasError);

    if (formHasError) {
      let checkIndex = _.findIndex(assigned[tid], (o) => {
        return o.ticketid === tid && o.index === tindex;
      });

      if (checkIndex >= 0) {
        // console.log("formerrors[tid] :- ", formerrors[tid][checkIndex]);

        if (!_.isEmpty(formerrors[tid][checkIndex])) {
          for (const prop in formerrors[tid][checkIndex]) {
            // console.log(`obj.${prop} = ${formerrors[tid][checkIndex][prop]}`);

            dispatch(setSubmitFailed(`${form}`, `${prop}`));
            dispatch(
              stopSubmit(`${form}`, { [prop]: LocaleStrings.kFieldRequired })
            );
          }
        }
      }
    }
  }, [assigned[tid]]);

  useEffect(() => {
    let data = { ...formValues };
    let error = { ...formErrors };
    onSubmitForm(data, error);
  }, [formErrors]);

  useEffect(() => {
    if (!_.isEmpty(pResponseData) && tindex === 0) {
      props.autofill("firstname", pResponseData?.firstname);
      props.autofill("lastname", pResponseData?.lastname);
      props.autofill("email", pResponseData?.email);
    }
  }, [pResponseData, formValues, tindex]);

  const onSubmitForm = (data, formErrors, field = "") => {
    // console.log("data :- ", data, formErrors);
    // console.log("formErrors submit :- ", formErrors);

    if (!_.isEmpty(data)) {
      // setLoading(true);
      let values = {
        email: data?.email?.trim().toLowerCase(),
        ticketid: tid,
        index: tindex,
        type: ticketGenre,
        ...(ticketGenre !== "addon"
          ? {
              firstname: data?.firstname?.trim(),
              lastname: data?.lastname?.trim(),
              interest: data?.interest ? _.uniqBy(data?.interest) : [],
            }
          : {}), // Its comes in array so by any chance if any interest id is duplicate, here we are removing.
      };

      let formData = [];
      let otherFilesData = [];
      if (ticketGenre !== "addon") {
        _.map(formArray, (form) => {
          let formKey = form?.key;
          let name = form?.name;
          let isReadOnly = form?.isreadonly ?? false;
          let isHidden = form?.hidden ?? false;

          if (
            formKey !== "label" &&
            formKey !== "hyperlink" &&
            formKey !== "paragraph" &&
            formKey !== "section" &&
            formKey !== "group"
          ) {
            if (data.hasOwnProperty(name)) {
              if (formKey === "datepicker") {
                let date = "";
                if (data[name] && data[name] !== "") {
                  if (data[name] && form?.pickertype == "range") {
                    data[name] = _.isString(data[name])
                      ? data[name]?.split(" - ")
                      : [];
                    date = data[name]
                      ?.map((d) => {
                        if (typeof d === "string" && checkDateFormatYMD(d)) {
                          return moment(new Date(Date.parse(d)))?.format(
                            DATE_FORMAT
                          );
                        } else {
                          return moment(d, DISPLAY_BROWSER_DATE_FORMAT)?.format(
                            DATE_FORMAT
                          );
                        }
                      })
                      .filter((d) => moment(d).isValid()); // Filter out invalid dates
                    date = date?.join(" - ");
                  } else {
                    if (data[name] && typeof data[name] === "string") {
                      if (checkDateFormatYMD(data[name])) {
                        let dateParse = new Date(Date.parse(data[name]));
                        date = moment(dateParse).format(DATE_FORMAT);
                      } else {
                        date = moment(
                          data[name],
                          DISPLAY_BROWSER_DATE_FORMAT
                        ).format(DATE_FORMAT);
                      }
                      if (!moment(date).isValid()) {
                        date = "";
                      }
                    } else {
                      date = moment(data[name]).format(DATE_FORMAT);
                    }
                  }
                }

                form.value = !isReadOnly && !isHidden ? date : "";
              } else if (formKey === "dropdown") {
                let checkType = typeof data[name];
                let val = "";
                if (checkType === "object") {
                  val = data?.[name]?.value ?? "";
                } else {
                  val = data?.[name] ?? "";
                }
                form.value = !isReadOnly && !isHidden ? val : "";
              } else if (formKey === "dynamicfield" && name === "interest") {
                // No value need to store here.
              } else {
                form.value = !isReadOnly && !isHidden ? data[name] : "";
                if (formKey === "checkboxes" || formKey === "file") {
                  form.value = !isReadOnly && !isHidden ? data[name] : [];
                }
              }
            } else {
              if (formKey === "checkboxes" || formKey === "file") {
                form.value = [];
              } else if (formKey === "dynamicfield" && name === "interest") {
                // No value need to store here.
              } else {
                form.value = "";
              }
            }
          }

          formData.push(form);
        });
        // console.log("formData :- ", formData);

        values.formid = formid;
        values.responses = JSON.stringify(formData);

        otherFilesData = _.filter(formData, (form) => {
          return form?.key === "file" && form?.value?.length > 0;
        });
      }
      // console.log("otherFilesData :- ", otherFilesData);
      // console.log("Final Value :- ", values);

      if (otherFilesData.length > 0) {
        _uploadDynamicFormsFiles(
          session,
          eventData?.eventid,
          otherFilesData,
          dispatch,
          (filesArray) => {
            // console.log("filesArray :- ", filesArray);
            _.map(formData, (obj) => {
              let check = _.filter(filesArray, function (file) {
                return file.name === obj.name;
              });

              if (check?.length > 0) {
                obj.value = check[0].value;
              }
            });
            // console.log("new formData :- ", formData);

            values = {
              ...values,
              responses: JSON.stringify(formData),
            };

            if (!assignedAttendeeTickets[tid]) {
              assignedAttendeeTickets[tid] = [values];
              assignedAttendeeErrors[tid] = [formErrors];
            } else {
              let checkIndex = _.findIndex(
                assignedAttendeeTickets[tid],
                (o) => {
                  return o.ticketid === tid && o.index === tindex;
                }
              );

              if (checkIndex >= 0) {
                assignedAttendeeTickets[tid][checkIndex] = values;
                assignedAttendeeErrors[tid][checkIndex] = formErrors;
              } else {
                assignedAttendeeTickets[tid].push(values);
                assignedAttendeeErrors[tid].push(formErrors);
              }
            }
            handleUpdateAssigned(
              assignedAttendeeTickets,
              assignedAttendeeErrors,
              data,
              field
            ); // update the redux

            // setTimeout(() => {
            //   setLoading(false);
            // }, 500);
          }
        );
      } else {
        if (!assignedAttendeeTickets[tid]) {
          assignedAttendeeTickets[tid] = [values];
          assignedAttendeeErrors[tid] = [formErrors];
        } else {
          let checkIndex = _.findIndex(assignedAttendeeTickets[tid], (o) => {
            return o.ticketid === tid && o.index === tindex;
          });

          if (checkIndex >= 0) {
            assignedAttendeeTickets[tid][checkIndex] = values;
            assignedAttendeeErrors[tid][checkIndex] = formErrors;
          } else {
            assignedAttendeeTickets[tid].push(values);
            assignedAttendeeErrors[tid].push(formErrors);
          }
        }
        handleUpdateAssigned(
          assignedAttendeeTickets,
          assignedAttendeeErrors,
          data,
          field
        ); // update the redux

        // setTimeout(() => {
        //   setLoading(false);
        // }, 500);
      }
    }
    // console.log(attendeeerrors, minattendees);
  };

  const handleUpdateAssigned = (assigned, formerrors, data, field) => {
    // console.log("data update :- ", data);
    // console.log("assigned 1 :- ", assigned);
    // console.log("formerrors 1 :- ", formerrors);

    if (availableForSelfAssign) {
      if (
        ticketGenre === "general" &&
        validateEmail(data?.email ?? "") &&
        field === "email"
      ) {
        // console.log("addonTicketsArr :- ", addonTicketsArr);

        _.map(addonTicketsArr, (item, index) => {
          let aotid = item?.ticketid;
          let qty = item?.quantity;
          let valObj = {
            email: data?.email?.trim().toLowerCase(),
            ticketid: aotid,
          };

          if (!assigned[aotid]) {
            let addonvalues = [];
            let addonerrors = [];
            for (let i = 0; i < qty; i++) {
              addonvalues.push({ ...valObj, index: i });
              addonerrors.push({});
            }
            assigned[aotid] = [...addonvalues];
            formerrors[aotid] = [...addonerrors];
          } else {
            for (let i = 0; i < qty; i++) {
              let checkIndex = _.findIndex(assigned[aotid], (o) => {
                return o.ticketid === aotid && o.index === i;
              });

              if (checkIndex >= 0) {
                assigned[aotid][checkIndex] = { ...valObj, index: i };
                formerrors[aotid][checkIndex] = {};
              } else {
                assigned[aotid].push({ ...valObj, index: i });
                formerrors[aotid].push({});
              }
            }
          }
        });
      }
    }
    // console.log("assigned 2 :- ", assigned);
    // console.log("formerrors 2 :- ", formerrors);

    props.updateTicketAssignedAttendee(assigned);
    props.updateTicketAssignedError(formerrors);
  };

  const callSubmit = (e) => {
    let name = e?.target?.name;
    let value = e?.target?.value;
    // console.log("name :- ", name, value);

    let data = { ...formValues };
    let error = { ...formErrors };

    if (value && value.trim() !== "") {
      if (availableForSelfAssign) {
        if (ticketGenre === "general" && name === "email") {
          // I have calling onSubmitForm call from here only in this if condition. Now we are calling this from userEffect method.
          // console.log("1");
          onSubmitForm(data, error, name); // Call this method to store attendee form details locally
        }
      } else {
        // I have removed onSubmitForm call from here. Now we are calling this from userEffect method.
        // console.log("2");
        // onSubmitForm(data, error); // Call this method to store attendee form details locally
      }
    }
  };

  const updatedLastField = (field, value) => {
    let data = { ...formValues };
    let error = { ...formErrors };
    let key = field.key;
    let name = field.name;
    data[name] = value;
    // console.log("field, value :- ", field, value);

    if (value && !_.isEmpty(value)) {
      delete error[name];
    } else {
      let exist = _.filter(fieldsArr, (o) => o?.name === name);

      if (exist?.length > 0 && exist?.[0]?.required) {
        error[name] = LocaleStrings.kFieldRequired;
      }
    }
    // console.log("error :- ", error);

    if (availableForSelfAssign) {
      if (ticketGenre === "general") {
        // I have removed onSubmitForm call from here. Now we are calling this from userEffect method.
        // console.log("1");
        // onSubmitForm(data, error); // Call this method to store attendee form details locally
      }
    } else {
      // I have removed onSubmitForm call from here. Now we are calling this from userEffect method.
      // console.log("2");
      // onSubmitForm(data, error); // Call this method to store attendee form details locally
    }

    // We are calling onSubmitForm for file upload as it is not working from userEffect method.
    if (key === "file") {
      onSubmitForm(data, error); // Call this method to store attendee form details locally
    }

    setLastFieldUpdated(name);
  };

  const handleEmailCheck = (e) => {
    let email = e.target.value;

    if (validateEmail(email)) {
      let values = { ticketid: tid, eventid: eventData?.eventid, email: email };

      props.validateAssignedEmail(session, values, (response) => {
        // console.log("response :- ", response);
        if (response?.success === 2) {
          let message = "";
          if (response?.data?.code === "email_not_associated_with_event") {
            message = LocaleStrings.kThisEmailNotRegistered;
          } else if (response?.data?.code === "email_domain_not_allowed") {
            message = _.replace(
              LocaleStrings.kInvalidEmailDomainText,
              "###DOMAIN###",
              response?.data?.resource?.domain
            );
          } else if (response?.data?.code === "email_already_in_use") {
            message = LocaleStrings.kEmailAlreadyRegisteredText;
          } else if (
            response?.data?.code === "user_have_other_access_permission"
          ) {
            message = LocaleStrings.kUserHaveOtherAccessPermissionText;
          } else if (
            response?.data?.code ===
            "email_already_assigned_with_current_ticket"
          ) {
            message = LocaleStrings.kEmailAlreadyHaveCurrentTicketAccessText;
          } else {
            message = LocaleStrings.kSomethingWentWrongMsg;
          }
          dispatch(setSubmitFailed(`${form}`, "email"));
          dispatch(stopSubmit(`${form}`, { email: message }));
        } else {
          dispatch(stopSubmit(`${form}`, {}));
          dispatch(untouch(`${form}`, "email"));
        }
      });
    }
  };

  const handleAccordion = () => {
    if (availableForSelfAssign && ticketGenre === "addon") {
      setContentOpen(false);
    } else {
      if (openContent) {
        setContentOpen(false);
      } else {
        setContentOpen(true);
      }
    }
  };

  const renderSinglePageSections = () => {
    // console.log("allConditionalFields :- ", allConditionalFields);
    // console.log("sectionWiseArray :- ", sectionWiseArray);
    // console.log("lastFieldUpdated :- ", lastFieldUpdated);
    // console.log("formValues :- ", formValues);

    let renderFieldsArr = [];
    for (let pi = 0; pi < sectionWiseArray?.length; pi++) {
      let field = sectionWiseArray[pi];
      let name = field?.name;

      let ishidden = handleShowHide(
        name,
        formValues,
        props.autofill,
        lastFieldUpdated,
        allConditionalFields
      );

      // console.log("section ishidden :- ", name, ishidden);
      // console.log("-------------------");

      if (ishidden === 0)
        renderFieldsArr.push(
          <SectionList
            key={name}
            source="ticketassign"
            section={field}
            autofill={props.autofill}
            formValues={formValues}
            tLastFieldUpdated={lastFieldUpdated}
            tAllConditionalFields={allConditionalFields}
            tsectionWiseArray={sectionWiseArray}
            updatedLastFieldChanged={updatedLastField}
          />
        );
    }

    // console.log("renderFieldsArr :- ", renderFieldsArr);
    return renderFieldsArr;
  };
  // console.log("assignformdisplay :- ", assignformdisplay);
  // console.log("lastFieldUpdated :- ", lastFieldUpdated);
  // console.log("formValues :- ", formValues);
  // console.log("formErrors :- ", formErrors);
  // console.log("assignedAttendeeTickets :- ", assignedAttendeeTickets);
  // console.log("assignedAttendeeErrors :- ", assignedAttendeeErrors);
  // console.log("isProposalTicket :- ", isProposalTicket);

  return (
    <>
      <li className="rounded-md border border-default">
        <div
          className={classNames(
            availableForSelfAssign && ticketGenre === "addon"
              ? ""
              : "cursor-pointer",
            "py-4 px-4 flex items-center justify-between border-b"
          )}
          onClick={handleAccordion}
        >
          <div className="flex items-center space-x-4">
            <div>
              <CheckCircleIcon
                className={classNames(
                  formValues &&
                    Object.keys(formValues).length > 0 &&
                    formErrors &&
                    Object.keys(formErrors).length === 0
                    ? "text-customgreen"
                    : "",
                  "w-6 h-6"
                )}
              />
            </div>

            <div className="flex space-x-1.5">
              {hasChild ? (
                <span className="custom-text-primary-md-bold">#{position}</span>
              ) : (
                <>
                  {quantity > 1 ? (
                    <span className="custom-text-primary-md-bold">
                      #{position}
                    </span>
                  ) : (
                    ""
                  )}
                </>
              )}
              <div className="custom-text-primary-md-normal">
                {" "}
                {assign?.name}
                {assign?.minattendees &&
                  assign.index < assign?.minattendees && (
                    <span className="label-mandatory">*</span>
                  )}
                <span>
                  {" "}
                  {availableForSelfAssign && ticketGenre === "addon" ? (
                    <>
                      <p className="custom-text-primary-sm-normal ">
                        {formValues?.email ?? ""}
                      </p>
                    </>
                  ) : (
                    ""
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-6">
            {availableForSelfAssign && ticketGenre === "addon" ? (
              <></>
            ) : (
              <>
                {assignflow == "beforepayment" &&
                assign.ticketassignflow == "afterpayment" &&
                clientbuildno > 6 ? (
                  <p style={{ color: "red" }}>
                    {LocaleStrings.kAssignUserAfterPayment}
                  </p>
                ) : openContent ? (
                  <ChevronUpIcon className="w-5 h-5" />
                ) : (
                  <ChevronDownIcon className="w-5 h-5" />
                )}
              </>
            )}
          </div>
        </div>

        {/* content */}
        {(
          clientbuildno > 6
            ? assignflow == "beforepayment" &&
              assign.ticketassignflow == "beforepayment"
            : clientbuildno < 7
        ) ? (
          <div className={`${openContent ? "" : "hidden"}`}>
            <>
              <div className="bg-default px-4 py-4">
                {/* Form section */}
                <form onSubmit={handleSubmit(onSubmitForm)} autoComplete="none">
                  {ticketGenre === "addon" ? (
                    <>
                      <Field
                        name={`email`}
                        label={LocaleStrings.kEmail}
                        placeholder={LocaleStrings.kEnterEmailAddress}
                        type="text"
                        component={renderFieldText}
                        mandatory={true}
                        onChange={handleEmailCheck}
                        onBlur={callSubmit}
                      />
                    </>
                  ) : (
                    <div className="base-form">
                      {assignformdisplay === "long" ? (
                        <>
                          <div className="rounded-xl border border-default">
                            <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
                              <div className="custom-text-primary-md-medium">
                                {LocaleStrings.kProfileSectionTitle}
                              </div>
                              <div className="custom-text-secondary-sm-medium">
                                {LocaleStrings.kProfileSectionDesc}
                              </div>
                            </div>
                            <dl className="base-form bg-white rounded-b-xl px-6 py-4">
                              <div className="md:grid grid-cols-4 md:space-x-6 space-y-2 2xs:space-y-4 md:space-y-0">
                                <div className="col-span-2">
                                  <Field
                                    name={`firstname`}
                                    label={LocaleStrings.kFirstName}
                                    placeholder={
                                      LocaleStrings.kPlaceholderFirstName
                                    }
                                    type="text"
                                    component={renderFieldText}
                                    mandatory={true}
                                    onBlur={callSubmit}
                                    disabled={isProposalTicket}
                                  />
                                </div>
                                <div className="col-span-2">
                                  <Field
                                    name={`lastname`}
                                    label={LocaleStrings.kLastName}
                                    placeholder={LocaleStrings.kEnterLastName}
                                    type="text"
                                    component={renderFieldText}
                                    mandatory={true}
                                    onBlur={callSubmit}
                                    disabled={isProposalTicket}
                                  />
                                </div>
                              </div>
                              <Field
                                name={`email`}
                                label={LocaleStrings.kEmail}
                                placeholder={LocaleStrings.kEnterEmailAddress}
                                type="text"
                                component={renderFieldText}
                                mandatory={true}
                                onChange={handleEmailCheck}
                                onBlur={callSubmit}
                                disabled={isProposalTicket}
                                autocomplete="off"
                              />
                            </dl>
                          </div>
                          {renderSinglePageSections()}
                        </>
                      ) : (
                        <>
                          <div className="md:grid grid-cols-4 md:space-x-6 space-y-2 2xs:space-y-4 md:space-y-0">
                            <div className="col-span-2">
                              <Field
                                name={`firstname`}
                                label={LocaleStrings.kFirstName}
                                placeholder={
                                  LocaleStrings.kPlaceholderFirstName
                                }
                                type="text"
                                component={renderFieldText}
                                mandatory={true}
                                onBlur={callSubmit}
                                disabled={isProposalTicket}
                              />
                            </div>
                            <div className="col-span-2">
                              <Field
                                name={`lastname`}
                                label={LocaleStrings.kLastName}
                                placeholder={LocaleStrings.kEnterLastName}
                                type="text"
                                component={renderFieldText}
                                mandatory={true}
                                onBlur={callSubmit}
                                disabled={isProposalTicket}
                              />
                            </div>
                          </div>
                          <Field
                            name={`email`}
                            label={LocaleStrings.kEmail}
                            placeholder={LocaleStrings.kEnterEmailAddress}
                            type="text"
                            component={renderFieldText}
                            mandatory={true}
                            onChange={handleEmailCheck}
                            onBlur={callSubmit}
                            disabled={isProposalTicket}
                          />
                        </>
                      )}
                    </div>
                  )}

                  {/* <div className="mt-4">
                  <button
                    type="submit"
                    className="theme-button-outer-md w-full"
                    disabled={pristine || invalid || submitting || loading}
                  >
                    <svg
                      className={classNames(
                        loading ? "" : "hidden",
                        "cust-btn-spinner"
                      )}
                      viewBox="0 0 1024 1024"
                      focusable="false"
                      data-icon="btnloading"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                    </svg>{" "}
                    {LocaleStrings.kSaveText}
                  </button>
                </div> */}
                </form>
              </div>
            </>
          </div>
        ) : (
          ""
        )}
      </li>
    </>
  );
};

const validate = (values, ownProps) => {
  // console.log("validate values :- ", values);

  let eventUserCategories = ownProps?.eventUserCategories?.data ?? []; // Event user categories
  let pResponseData = ownProps?.pResponseData; // Proposal response data. Proposal ticket
  let manageTicketsCount = ownProps?.manageTicketsCount; // Selected tickets list
  let assigned = JSON.parse(
    JSON.stringify(ownProps?.assignedAttendeeTickets ?? [])
  ); // All assigned attendees
  // let attendeeerrors = JSON.parse(
  //   JSON.stringify(ownProps?.assignedAttendeeErrors ?? [])
  // ); // All assigned attendees
  let assign = ownProps?.assign;
  // let minattendees = ownProps?.assign?.minattendees;

  let tid = assign?.ticketid;
  let assignformdisplay = assign?.assignformdisplay;
  let ticketGenre = assign?.type;
  let usercategory = assign?.usercategory;
  let tindex = assign?.index;
  // console.log("manageTicketsCount :- ", manageTicketsCount);

  // Get the General Tickets
  let assignedGeneralTickets = {};
  for (let [key, item] of Object.entries(assigned)) {
    let checkTicket = _.filter(
      manageTicketsCount,
      (o) => parseInt(o.ticketid) === parseInt(key)
    );

    if (checkTicket.length > 0 && checkTicket?.[0]?.type !== "addon") {
      assignedGeneralTickets[key] = item;
    }
  }
  // console.log("assignedGeneralTickets :- ", assignedGeneralTickets);

  let errors = {};
  if (
    ownProps?.clientbuildno > 6
      ? ownProps.assignflow === "beforepayment" &&
        assign.ticketassignflow === "beforepayment"
      : ownProps?.clientbuildno < 7
  ) {
    let firstname = values[`firstname`];
    let lastname = values[`lastname`];
    let email = values[`email`];

    if (ticketGenre !== "addon") {
      if (!firstname || firstname.trim() === "") {
        errors[`firstname`] = LocaleStrings.kFieldRequired;
      }
      if (!lastname || lastname.trim() === "") {
        errors[`lastname`] = LocaleStrings.kFieldRequired;
      }
    }
    if (!email || email.trim() === "") {
      errors[`email`] = LocaleStrings.kFieldRequired;
    } else if (email && !validateEmail(email)) {
      errors[`email`] = LocaleStrings.kInvalidEmail;
    } else if (
      email &&
      !_.isEmpty(pResponseData) &&
      tindex === 0 &&
      pResponseData?.email !== email
    ) {
      // allow only submited email for the proposal.
      errors[`email`] = LocaleStrings.kAbstractResEmailChangeRestrictText;
    } else if (email) {
      if (ticketGenre !== "addon") {
        // Logic to check if same ticket have same email multiple time
        let currentTicketUsers = assignedGeneralTickets?.[tid] ?? []; // Filter the current ticket assigned attendees
        let checkIndex = _.findIndex(currentTicketUsers, (o) => {
          return o.ticketid === tid && o.index === tindex;
        });

        if (checkIndex >= 0) {
          currentTicketUsers[checkIndex].email = email;
        }
        // console.log("currentTicketUsers :- ", currentTicketUsers);

        let assignedEmails = [];
        currentTicketUsers.forEach((o) => {
          if (o?.email && o?.email !== "" && validateEmail(o?.email)) {
            assignedEmails.push(o?.email);
          }
        });
        // console.log("assignedEmails :- ", assignedEmails);

        let groupped = _.groupBy(assignedEmails, function (e) {
          return e;
        }); // Grouping array by eamils
        // console.log("groupped :- ", groupped);

        let duplicatesArr = _.uniq(
          _.flatten(
            _.filter(groupped, function (n) {
              return n.length > 1;
            })
          )
        ); // Getting the duplicates values from groupped array whose length is > 1
        // console.log("duplicatesArr :- ", duplicatesArr);
        if (duplicatesArr.length > 0 && _.includes(duplicatesArr, email)) {
          errors["email"] = _.replace(
            LocaleStrings.kAssignedUsersDuplicateEmailInSameTicketText,
            "###EMAIL###",
            email
          );
        }

        // Logic to check if diff ticket have same email
        let diffTicketAssignedEmails = [];
        for (let [key, item] of Object.entries(assignedGeneralTickets)) {
          let checkTicket = _.filter(
            manageTicketsCount,
            (o) => parseInt(o.ticketid) === parseInt(key)
          );
          let isUpgradable =
            checkTicket?.length > 0 && checkTicket[0]["allowoverride"]
              ? true
              : false;
          let tname = checkTicket?.length > 0 ? checkTicket[0]["name"] : "";

          // console.log("isUpgradable :- ", isUpgradable);

          let diffTicketEmails = [];
          item.forEach((o) => {
            if (o?.email && o?.email !== "" && validateEmail(o?.email)) {
              diffTicketEmails.push({
                email: o?.email,
                ticketid: o.ticketid,
                ticketname: tname,
                allowoverride: isUpgradable,
              });
            }
          });
          // console.log("obj :- ", key, diffTicketEmails);
          diffTicketAssignedEmails.push(_.uniq(diffTicketEmails, "email"));
        }
        diffTicketAssignedEmails = _.flatten(diffTicketAssignedEmails);
        // console.log("diffTicketAssignedEmails :- ", diffTicketAssignedEmails);

        diffTicketAssignedEmails.forEach((obj) => {
          let tid = obj.ticketid;
          let email = obj.email;

          let isUpgradable = obj.allowoverride;

          let checkDuplicate = _.filter(diffTicketAssignedEmails, (o) => {
            return isUpgradable
              ? o.ticketid !== tid && o.email === email && !o.allowoverride
              : o.ticketid !== tid && o.email === email;
          });
          // console.log("checkDuplicate :- ", checkDuplicate);

          if (checkDuplicate.length > 0) {
            let ticketsName = _.map(checkDuplicate, (o) => o.ticketname).join(
              ", "
            );
            errors["email"] =
              LocaleStrings.kAssignedUsersDuplicateEmailInDifferentTicketText
                .replaceAll("###EMAIL###", email)
                .replaceAll("###TICKET###", ticketsName);
          }
        });
      }

      // Logic to validate email domain which are whitelisted
      let tCategory = usercategory;
      let check = _.filter(
        eventUserCategories,
        (o) =>
          parseInt(o.id) === parseInt(tCategory) &&
          o?.allowemaildomain &&
          o?.allowemaildomain !== ""
      );
      let allowedEmailDomain =
        check?.length > 0 ? check[0].allowemaildomain.trim() : "";
      // console.log("allowedEmailDomain :- ", allowedEmailDomain);

      if (!validateEmailDomain(allowedEmailDomain, email)) {
        let emailDomain = email?.split("@")?.[1];
        errors["email"] = _.replace(
          LocaleStrings.kInvalidEmailDomainText,
          "###DOMAIN###",
          emailDomain
        );
      }
    }

    if (assignformdisplay === "long") {
      let formArray = [];
      if (ownProps?.eventUserCategories?.data) {
        let matchCat = _.filter(ownProps?.eventUserCategories?.data, (obj) => {
          return obj.id === usercategory;
        });
        formArray =
          matchCat?.length > 0 ? JSON.parse(matchCat?.[0]?.formjson) : [];
      }
      // console.log("formArray :- ", formArray);
      // Get all has conditional fields
      let conditionalFields = _.filter(
        formArray,
        (obj) =>
          (obj.key === "radiobuttons" ||
            obj.key === "checkboxes" ||
            obj.key === "dropdown") &&
          obj.hasCondition
      );
      let allConditionalFields = conditionalFields;

      // Create section wise fields
      let fieldsArr = JSON.parse(JSON.stringify(formArray));
      let currentSection = "";
      let sectionWiseArr = [];
      _.map(fieldsArr, (o) => {
        let key = o.key;

        if (key === "section") {
          currentSection = o?.name;
          o.elements = [];
          sectionWiseArr.push(o);
        } else {
          let index = _.findIndex(sectionWiseArr, (e) => {
            return e?.name === currentSection;
          });

          if (index >= 0) {
            sectionWiseArr[index].elements.push(o);
          }
        }
      });
      let sectionWiseArray = sectionWiseArr;
      // console.log("sectionWiseArray :- ", sectionWiseArray);

      let currentSectionData = [];
      _.map(formArray, (form, index) => {
        let key = form?.key;
        let name = form?.name;
        let isReadOnly = form?.isreadonly ?? false;
        let isHidden = form?.hidden ?? false;
        let isRequired =
          form?.required && !isReadOnly && !isHidden ? true : false;
        let isExclude = form?.exclude ?? false;
        if (key === "section") {
          // check current section and updated the currentSectionData veriable
          let check = _.filter(sectionWiseArray, (o) => o.name === name);
          currentSectionData = check.length > 0 ? check[0] : [];
        }
        // console.log("currentSectionData :- ", currentSectionData);
        // console.log("allConditionalFields :- ", allConditionalFields);

        let relatedWith = [];
        allConditionalFields.forEach((item) => {
          let fName = item.name;
          let fKey = item.key;
          let options = item.options;
          let check = _.filter(options, (val) => {
            return val?.displayfields.indexOf(name) > -1;
          });
          // console.log("check :- ", name, check);

          if (check.length > 0) {
            let val = [];
            check.forEach((v) => {
              val.push(v?.value);
            });

            relatedWith.push({
              key: fKey,
              name: fName,
              value: val,
            });
          }
        });
        // console.log(name, relatedWith);

        // Check field is hidden or not
        let ishidden = handleShowHide(
          name,
          ownProps.formValues,
          ownProps.autofill,
          null,
          allConditionalFields,
          sectionWiseArray
        );
        // console.log("field active  :- ", name, ishidden);

        // Check currect fields parent section status
        let isSectionHidden = 0;
        if (key !== "section") {
          let currentSectionFields = currentSectionData?.elements ?? [];
          let currentSectionName = currentSectionData.name;

          let check = _.filter(currentSectionFields, (o) => o.name === name);
          if (check.length > 0) {
            // Check current field parent section is hidden or not
            isSectionHidden = handleShowHide(
              currentSectionName,
              ownProps.formValues,
              ownProps.autofill,
              null,
              allConditionalFields
            );
          }
        }

        if (!isExclude && ishidden === 0 && isSectionHidden === 0) {
          if (isRequired && !values[name]) {
            // Check either this filed linked with other fields or not
            if (relatedWith.length > 0) {
              let match = [];
              _.map(relatedWith, (rel) => {
                if (values[rel?.name]) {
                  // console.log("option val :- ", values[rel?.name]);
                  if (rel?.key === "checkboxes") {
                    let common = _.intersection(values[rel?.name], rel?.value);
                    match = _.concat(match, common);
                  } else {
                    let common = _.filter(
                      rel?.value,
                      (o) => o === values[rel?.name]
                    );
                    match = _.concat(match, common);
                  }
                }
              });
              // console.log("match :- ", name, match);
              if (match.length > 0) {
                // console.log(name, "Required...........................");
                errors[name] = LocaleStrings.kFieldRequired;
              }
            } else {
              errors[name] = LocaleStrings.kFieldRequired;
            }
          } else if (isRequired && values[name]) {
            let valueType = typeof values[name];
            // console.log("valueType :- ", valueType);

            if (key !== "datepicker" && valueType !== "boolean") {
              if (valueType === "string" && values[name].trim() === "") {
                errors[name] = LocaleStrings.kFieldRequired;
              } else if (_.isEmpty(values[name])) {
                errors[name] = LocaleStrings.kFieldRequired;
              }
            }
          }
          if (
            (name === "facebook" ||
              name === "twitter" ||
              name === "linkedin") &&
            values[name] &&
            !validateUrl(values[name])
          ) {
            errors[name] =
              name === "facebook"
                ? LocaleStrings.kInvalidFacebookLinkText
                : name === "twitter"
                ? LocaleStrings.kInvalidTwitterLinkText
                : name === "linkedin"
                ? LocaleStrings.kInvalidLinkedinLinkText
                : LocaleStrings.kInvalidUrlText;
          }
          // if (
          //   (name === "isnetworking" || name === "termsconditions") &&
          //   !values[name]
          // ) {
          //   errors[name] = LocaleStrings.kFieldRequired;
          // }
          if (
            form?.maxlen &&
            values?.[name] &&
            values?.[name]?.length > form?.maxlen
          ) {
            errors[name] = `${_.replace(
              LocaleStrings.kTextMaxLengthText,
              "#maxlength",
              form?.maxlen
            )}`;
          }
          if (
            (name === "phonenumber" || name === "whatsapp") &&
            values?.[name] &&
            !validatePhoneNumbers(values?.[name])
          ) {
            errors[name] = LocaleStrings.kInvalidPhoneText;
          }
        }
      });
    }
  }

  // console.log("validation errors :- ", errors);
  return errors;
};

const initCheckoutForm = (formArray) => {
  let init = {};

  _.forEach(formArray, (obj) => {
    let formKey = obj.key;
    let name = obj.name;
    let savedValue = obj?.value ?? "";
    if (formKey === "checkboxes" || formKey === "file") {
      savedValue = obj?.value ?? [];
    }

    if (
      formKey !== "label" &&
      formKey !== "hyperlink" &&
      formKey !== "paragraph" &&
      formKey !== "section" &&
      formKey !== "group"
    ) {
      if (formKey === "datepicker") {
        let date = "";
        if (savedValue && savedValue !== "") {
          if (savedValue && obj.pickertype == "range" && savedValue !== "") {
            savedValue = _.isString(savedValue) ? savedValue.split(" - ") : [];
            date = savedValue
              ?.map((d) => {
                if (typeof d === "string" && checkDateFormatYMD(d)) {
                  return moment(new Date(Date.parse(d))).format(DATE_FORMAT);
                } else {
                  return moment(d, DISPLAY_BROWSER_DATE_FORMAT)?.format(
                    DATE_FORMAT
                  );
                }
              })
              .filter((d) => moment(d)?.isValid()); // Filter out invalid dates

            date = date?.join(" - ");
          } else {
            if (
              savedValue &&
              typeof savedValue === "string" &&
              savedValue !== ""
            ) {
              if (checkDateFormatYMD(savedValue)) {
                let dateParse = new Date(Date.parse(savedValue));
                date = moment(dateParse).format(DATE_FORMAT);
              } else {
                date = moment(savedValue, DISPLAY_BROWSER_DATE_FORMAT).format(
                  DATE_FORMAT
                );
              }
              if (!moment(date).isValid()) {
                date = "";
              }
            } else {
              date = moment(savedValue).format(DATE_FORMAT);
            }
          }
        }

        init[name] = date;
      } else if (formKey === "dropdown") {
        let checkType = typeof savedValue;
        let val = "";
        if (checkType === "object") {
          val = savedValue?.value ?? "";
        } else {
          val = savedValue ?? "";
        }
        init[name] = val;
      } else if (formKey === "dynamicfield" && name === "interest") {
        // No value need to store here.
      } else {
        if (formKey === "checkboxes") {
          init[name] = savedValue;
        } else if (formKey === "file") {
          // let filesArr = [];
          // _.forEach(savedValue, (item) => {
          //   let f1 = item.split("/").pop();
          //   let f2 = f1.split("_");
          //   f2.shift();

          //   let fileName = f2.join("_");
          //   filesArr.push({ file: item, filename: fileName });
          // });
          init[name] = getFileDataArray(savedValue);
        } else {
          init[name] = savedValue;
        }
      }
    }
  });

  return init;
};

const mapStateToProps = (state, ownProps) => {
  let assign = ownProps?.assign;
  let tid = assign?.ticketid;
  let tindex = assign?.index;
  let ticketGenre = assign?.type;
  let pResponseData = state?.ticketLists?.responsedata ?? {}; // Proposal response data. Proposal ticket
  // console.log("assignedAttendeeTickets :- ", state.assignedAttendeeTickets);
  // console.log("pResponseData", pResponseData);

  let init =
    ticketGenre !== "addon"
      ? {
          firstname: null,
          lastname: null,
          email: null,
          isnetworking: false,
          termsconditions: false,
        }
      : { email: null };

  if (!_.isEmpty(pResponseData) && tindex === 0) {
    init.email = pResponseData?.email ?? "";
    init.firstname = pResponseData?.firstname ?? "";
    init.lastname = pResponseData?.lastname ?? "";

    let formArray = JSON.parse(pResponseData?.response_JSON ?? []);
    let callFormInit = initCheckoutForm(formArray);
    // console.log("callFormInit :- ", callFormInit);

    init = { ...callFormInit, ...init };
  }

  if (state.assignedAttendeeTickets[tid]) {
    let checkIndex = _.findIndex(state.assignedAttendeeTickets[tid], (o) => {
      return o.ticketid === tid && o.index === tindex;
    });

    if (checkIndex >= 0) {
      let values = state.assignedAttendeeTickets[tid][checkIndex];
      init.email = values?.email;
      if (ticketGenre !== "addon") {
        init.firstname = values?.firstname ?? "";
        init.lastname = values?.lastname ?? "";
        init.interest = values?.interest;

        let formArray = JSON.parse(values?.responses ?? []);
        let callFormInit = initCheckoutForm(formArray);
        // console.log("callFormInit :- ", callFormInit);

        init = { ...init, ...callFormInit };
      }
    }
  }
  // console.log("init :- ", init);
  return {
    session: state.session,
    initialValues: init,
    eventData: state.eventData,
    eventUserCategories: state.eventUserCategories,
    manageTicketsCount: state.manageTicketsCount,
    assignedAttendeeTickets: state.assignedAttendeeTickets,
    assignedAttendeeErrors: state.assignedAttendeeErrors,
    pResponseData,

    formValues: getFormValues(ownProps.form)(state),
    formErrors: state?.form?.[ownProps.form]?.syncErrors ?? {},
    assignflow: state.assignflow,
    clientbuildno: state.eventData?.clients_by_clientidfk?.buildno ?? 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      validateAssignedEmail,
      updateTicketAssignedAttendee,
      updateTicketAssignedError,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(TicketAssign)
);
